// extracted by mini-css-extract-plugin
export default {"modal":"techIssueAlert_modal__+s2M6"};